/**
 * Filters out unsupported diagnosis code values.
 * Returns the diagnosis value if it exists and is not 'N/A', otherwise returns undefined.
 *
 * @param diagnosis - The diagnosis object with an optional value property
 * @returns The diagnosis value string or undefined
 */
export function filterUnsupportedDiagnosisCodeValues(diagnosis?: {
  value?: string;
}): string | undefined {
  if (!diagnosis?.value || diagnosis.value.toLowerCase() === 'n/a') {
    return undefined;
  }
  return diagnosis.value;
}
